import { css, GridCol, mixins, styled } from '@bob/library'

export type BackgroundBrickWrapperProps = {
  parallaxOffset?: number
}

export type BackgroundBrickStyleProps = {
  reversedLayout?: boolean
}

export const BackgroundBrickWrapper = styled(GridCol)<BackgroundBrickWrapperProps>`
  position: relative;
  ${mixins.margin.top(100)}
  ${({ parallaxOffset }) =>
    css`
      transform: translate3D(0, ${parallaxOffset ?? 0}px, 0);
      transition-duration: 0.2s;
      transition-timing-function: ease;
    `}
`
export const BackgroundBrick = styled.div<BackgroundBrickStyleProps>`
  ${mixins.media.min.desktop} {
    ${({ theme, reversedLayout }) => css`
      position: absolute;
      top: 0;
      ${reversedLayout
        ? css`
            left: 0;
            transform: translate(-20%, -20%) scale(0.9);
          `
        : css`
            right: 0;
            transform: translate(20%, -20%) scale(0.9);
          `};
      z-index: -1;
      width: 100%;
      padding-bottom: 100%;
      background-color: ${theme.colorTheme.bgColor};
    `}
  }
`
